<mat-radio-group
  class="kind-group"
  [value]="selectedKind"
  [disabled]="!editMode"
  (change)="onKindChange($event.value)">

  @if (showNotAvailable) {
    <mat-radio-button value="not-available">N/A</mat-radio-button>
  }
  <mat-radio-button value="closed">Closed</mat-radio-button>
  <mat-radio-button value="open24">Open 24h</mat-radio-button>
  <mat-radio-button value="ranges">Hours</mat-radio-button>
</mat-radio-group>

@if (selectedKind === 'ranges') {
  <div class="ranges-section">
    @for (range of timeRanges; track $index; let i = $index) {
      <div class="slot-row">
        <gymfinder-time-input
          [time]="range.start"
          [disabled]="!editMode"
          (timeChange)="onTimeChange($event, 'start', i)">
        </gymfinder-time-input>

        <span class="slot-separator">&ndash;</span>

        <gymfinder-time-input
          [time]="range.end"
          [disabled]="!editMode"
          (timeChange)="onTimeChange($event, 'end', i)">
        </gymfinder-time-input>

        @if (editMode && timeRanges.length > 1) {
          <button
            mat-icon-button
            color="warn"
            matTooltip="Remove time slot"
            (click)="removeSlot(i)"
            type="button">
            <mat-icon>delete</mat-icon>
          </button>
        }

        @if (editMode && i === timeRanges.length - 1 && canAddTimeSlot) {
          <button
            mat-icon-button
            matTooltip="Add time slot"
            (click)="addSlot()"
            type="button">
            <mat-icon>add</mat-icon>
          </button>
        }

        @for (error of getSlotErrors(i); track error) {
          <gymfinder-alert variant="error" size="condensed">{{ error }}</gymfinder-alert>
        }
      </div>
    }

    @if (hasOverlapOrTouch) {
      <gymfinder-alert variant="error" size="condensed">Time slots must not overlap or touch</gymfinder-alert>
    }
  </div>
}
